var _rect, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRakutenTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    rx: 10.5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13, 10) scale(1.35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 2H11.2C14.6 2 17 4.5 17 7.8C17 10.3 15.6 12.3 13.4 13.4L18 20H14.5L10.7 14.3H7.2V20H4V2ZM11 10C12.7 10 14 8.7 14 7C14 5.3 12.7 4 11 4H7.2V10H11Z",
    fill: "#C40000"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 44L29 46.5L46 44L29 49Z",
    fill: "#C40000",
    opacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRakutenTv);
export default __webpack_public_path__ + "static/media/RakutenTV.28cd55ce12d304474b24a5b97da7b11f.svg";
export { ForwardRef as ReactComponent };